import Store from '@/store';
import SLSFamiliaComercialClient from '@/api/SistemaDKP/sls-familia-comercial.client';
import { ErrorMessage } from '@/libs/Error';

export default class SLSFamiliaComercialService {
  constructor() {
    this.client = new SLSFamiliaComercialClient();
    this.error = new ErrorMessage();
    this.store = Store;
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Familia Comercial');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Familia Comercial');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.client.update(id, data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Familia Comercial');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Familia Comercial');
    }
  }

  async getProdutosDestaque() {
    try {
      const data = await this.client.getProdutosDestaque(this.store.getters['slsFamiliaComercial/getFilters']);
      this.store.commit('slsFamiliaComercial/setProdutosDestaque', data);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os produtos em destaque');
    }
  }
}
